// extracted by mini-css-extract-plugin
export default {"Container":"VideoPlayer_Container__nLg+j","Loader":"VideoPlayer_Loader__PQKub"};